import { useParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { useQuery } from '@tanstack/react-query';
import { LanguageLocale } from '../../entities/LanguageLocale/index.js';
import { Accordion } from 'react-bootstrap';
import { PageBar } from '../../shared/ui/PageBar';

const SettingsOfLanguagePage = () => {
  const location = useParams();

  const { isPending, error, data } = useQuery({
    queryKey: ['getLanguageLocalizations'],
    queryFn: () => apiRequests.languages.getLocalizations(location.id),
  });

  return (
    <>
      <PageBar />

      <Accordion>
        {data && data.map((i) => <LanguageLocale key={i.title} parent={i} data={i} />)}
      </Accordion>
    </>
  );
};

export default SettingsOfLanguagePage;
